export default __webpack_public_path__ + "static/media/document-generic.8ce6c50e.svg";